module.exports = __webpack_public_path__ + "img/jörg_breitung.9567ea1a.jpg";